import React from 'react';

const useUnderlayClassname = (centered: boolean, isSecure: boolean): string => {
  return React.useMemo(() => {
    const classNames = [
      'fixed top-0 left-0 bottom-0 right-0 outline-none overflow-auto items-start'
    ];

    if (isSecure) {
      classNames.push('backdrop-blur backdrop-grayscale-[.8] z-[200000]');
    } else {
      classNames.push('z-1400');
    }

    if (centered) {
      classNames.push('items-center');
    }

    return classNames.join(' ');
  }, [centered, isSecure]);
};

export default useUnderlayClassname;
